import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import { Modal, Button } from "@mui/material";
import {
  AddAssetsSubType,
  AddAssetsType,
  getAmenitiesType,
  getAssetsName,
  subassets,
} from "../api/Users";
import { toast } from "react-toastify";

const AddAssetType = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [CategoryHandle, setCategoryHandle] = useState("");
  const [CategorySubHandle, setCategorySubHandle] = useState("");
  const [AssetsType, setAssetsType] = useState("");
  const [AssetSubtype, setAssetSubtype] = useState("");
  const [NewAssetSubtype, setNewAssetSubtype] = useState("");
  const [AssetsTypes, setAssetsTypes] = useState([]);
  const [AssetsSubTypes, setAssetsSubTypes] = useState([])
  const [AssetSubTypes, setAssetSubTypes]  = useState([])
  const [subTypeName, setSubTypeName] = useState('')

  useEffect(() => {
    getAmenitiesType()
      .then((res) => {
        if (res.status === "success") {
          console.log("amenities data:", res.data);
          setAssetsTypes(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  }, []);

  
  // const AssetTypehandle = async (e) => {
  //   const amenities = JSON.parse(e.target.value);
  //   console.log(amenities);
  //   setAssetsType(amenities.amenity_id);
  //   // setPostAmenityName(amenities.name);
  //   console.log("AssetsType", AssetsType);
  //   try {
  //     const response = await subassets({ amenity_id: amenities.amenity_id });
  //     if (response) {
  //       console.log(response.data.asset_name);
  //       setAssetsSubTypes(response.data.asset_name);
  //     } else {
  //       console.error("Invalid response format for subassets:", response);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching subassets:", error);
  //   }
  // };
  const AssetTypehandle = async (e) => {
    const selectedValue = e.target.value;
    console.log(selectedValue);
  
    if (!selectedValue) {
      console.error('Empty value received');
      return;
    }
  
    try {
      const amenities = JSON.parse(selectedValue);
      console.log(amenities);
  
      const amenityId = amenities.amenity_id;
      setAssetsType(amenityId);
  
      // Make API call to fetch subassets based on amenity_id
      const response = await subassets({ amenity_id: amenityId });
  
      if (response && response.status === "success") {
        console.log(response.data.asset_name);
        setAssetsSubTypes(response.data.asset_name);
      } else {
        console.error("Invalid response format for subassets:", response);
      }
    } catch (error) {
      console.error("Error parsing JSON or fetching subassets:", error);
    }
  };
  

  // const AssetSubtypehandle = async (e) => {
  //   const amenities = JSON.parse(e.target.value);
  //   setAssetSubtype(amenities.amenity_sub_type_id);
  //   // setPostAmenitySubName(amenities.name);
  // };
  const AssetSubtypehandle = async (e) => {
    const selectedValue = e.target.value;
    console.log(selectedValue);
  
    if (!selectedValue) {
      console.error('Empty value received');
      return;
    }
  
    try {
      const amenities = JSON.parse(selectedValue);
      console.log(amenities);
  
      const subtypeId = amenities.amenity_sub_type_id;
      setAssetSubtype(subtypeId);
  
      // You can optionally set the subtype name here
      // const subtypeName = amenities.name;
      // setPostAmenitySubName(subtypeName);
  
    } catch (error) {
      console.error("Error parsing JSON:", error);
    }
  };
  

  const handleSubTypeName = (e) => {
    setSubTypeName(e.target.value)
  }


  const form1 = useForm();
  const form2 = useForm();

  const {
    register: registerForm1,
    formState: { errors: errorsForm1 },
  } = form1;
  const {
    register: registerForm2,
    formState: { errors: errorsForm2 },
  } = form2;
  

  const handleSubmitForm1 = async (event) => {
    event.preventDefault();
    const Postdata = {
      category: CategorySubHandle,
      asset_id: NewAssetSubtype,
      asset_sub_type_name: AssetSubtype,
    };
    AddAssetsSubType(Postdata)
      .then((response) => {
        toast.success(response.message);
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error rejecting requirement:", error);
        toast.error(
          error.response?.data?.message || "Failed to reject requirement"
        );
      });
  };
  const clearAssetsFields = () => {
    window.location.reload();
  };
  const clearAssetsSubFields = () => {
    window.location.reload();
  };
  const [markRequired, setMarkRequired] = useState(true);


  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-2 px-md-4">
        <h5 className="my-4">{t("Add Amenity Sub Type")}</h5>
        {/* <button className={type === 'assign' ? 'btn btn-outline-success' : 'btn btn-success'} style={{fontSize:"14px"}} onClick={(e) => switchButton('view')}>{t('Create Inventory Type')} </button>
                <span className='mx-2 d-inline-block'></span>
                <button className={type === 'view' ? 'btn btn-outline-success' : 'btn btn-success'} style={{fontSize:"14px"}} onClick={(e) => switchButton('assign')}>{t('Create Inventory Sub Type')} </button> */}
        {/* <button
          className={
            type === "assign" ? "btn btn-outline-success" : "btn btn-success"
          }
          style={{
            fontSize: "14px",
            backgroundColor: type === "assign" ? "#fff" : "#102a83",
            borderColor: type === "assign" ? "#102a83" : "#fff",
            color: type === "assign" ? "#102a83" : "#fff",
          }}
          onClick={(e) => switchButton("view")}
        >
          {t("Add Amenity Sub Type")}{" "}
        </button> */}
        <span className="mx-2 d-inline-block"></span>
        {/* <button
          className={
            type === "view" ? "btn btn-outline-success" : "btn btn-success"
          }
          style={{
            fontSize: "14px",
            backgroundColor: type === "view" ? "#fff" : "#102a83",
            borderColor: type === "view" ? "#102a83" : "#fff",
            color: type === "view" ? "#102a83" : "#fff",
          }}
          onClick={(e) => switchButton("assign")}
        >
          {t("Add Amenity Sub Type")}{" "}
        </button> */}

        {/* {type === "view" ? (
          <form
            onSubmit={(e) => handleSubmitForm(e)}
            id="myform1"
            style={{ marginTop: "12px" }}
          >
            <div className="row">
              <div className="col-md-4">
                <label className="form-label">
                  {t("Existing Amenity Type")}{" "}
                  {markRequired && <span style={{ color: "red" }}>*</span>}
                </label>
                <select
                  name="asset_type_id"
                  // value={AssetsType}
                  className="common-input form-select"
                  onChange={AssetTypehandle}
                  required
                >
                  <option value="">{t("Select Amenity Type")}</option>
                  {/* Map assetOptions to generate option elements */}
        {/* {AssetsTypes.assets_name &&
                    AssetsTypes.assets_name.map((row) => (
                      <option key={row.amenity_id} value={row.amenity_id}>
                        {row.name}
                      </option>
                {/* </select>
              </div>
              <div className="col-md-4">
                <label className="form-label">
                  {t("Add New Amenity Type")}{" "}
                  {markRequired && <span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  type="text"
                  name="asset_type"
                  defaultValue=""
                  className="form-control"
                  onChange={Assettypehandle}
                  required
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-12">
                <button type="submit" className="btn btn-primary me-2">
                  {t("Submit")}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={clearAssetsFields}
                >
                  {t("Clear")}
                </button>
              </div>
            </div>
          </form> 
        ) : ( */}
        <form
          onSubmit={(e) => handleSubmitForm1(e)}
          id="myform2"
          style={{ marginTop: "12px" }}
        >
          <div className="row">
          <div className="col-md-4">
                <label className="form-label">
                  {t("Amenity Type")}{" "}
                  {markRequired && <span style={{ color: "red" }}>*</span>}
                </label>
                <select
                  name="asset_type_id"
                  className="common-input form-select"
                  onChange={AssetTypehandle}
                  required
                >
                  <option value="">{t("Select Amenity Type")}</option>
                  {/* Map assetOptions to generate option elements */}
                  {AssetsTypes.assets_name &&
                    AssetsTypes.assets_name.map((row, index) => (
                      <option key={index} value={JSON.stringify(row)}>
                        {row.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label">
                  {t("Amenity Sub Type")}{" "}
                  {markRequired && <span style={{ color: "red" }}>*</span>}
                </label>
                <select
                  name="asset_sub_type_id"
                  onChange={AssetSubtypehandle}
                  className="common-input form-select"
                  required
                >
                  <option value="">{t("Select Amenity Sub Type")}</option>

                  {AssetSubTypes &&
                    AssetsSubTypes.map((row, index) => (
                      <option key={index} value={JSON.stringify(row)}>
                        {row.name}
                      </option>
                    ))}
                </select>
              </div>
            <div className="col-md-3">
              <label className="form-label">
                {t("Add New Amenity Sub Type")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <div className="input-group mb-3">
                <input
                  type="text"
                  name="asset_sub_type_name"
                  defaultValue=""
                  className="form-control"
                  onChange={handleSubTypeName}
                  required
                />
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-12">
              <button type="submit" className="btn btn-primary me-2">
                {t("Submit")}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={clearAssetsSubFields}
              >
                {t("Clear")}
              </button>
            </div>
          </div>
        </form>
        {/* )} */}
      </div>
    </>
  );
};

export default AddAssetType;
